import { render, staticRenderFns } from "./NewAbonent.vue?vue&type=template&id=67dd2f4b"
import script from "./NewAbonent.vue?vue&type=script&lang=js"
export * from "./NewAbonent.vue?vue&type=script&lang=js"
import style0 from "./NewAbonent.vue?vue&type=style&index=0&id=67dd2f4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports